export const TITLE_OF_DOCUMENTS = {
  driverLicenseFront: 'Frontal',
  driverLicenseBack: 'Trasera',
};
